import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from "@vue/composition-api";
import { JSConn } from "@/utilities/js-conn";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import { WorkOrderSimple } from "@/store/modules/workOrders";

import { genericSort, sortIcon } from "@/components/helpers";
import { NamedRts } from "@/router";

import { format, startOfYear, endOfYear } from "date-fns";

import StatusIndicator from "@/components/StatusIndicator/StatusIndicator.vue";

import { filterOnInputHandler } from "@/utilities/pickListHelpers";

import {
  debouncedFilteredWorkOrders,
  apiWorkOrders,
  workOrders,
} from "@/components/WorkOrders/work-orders-shared";

export default defineComponent({
  name: "mWorkOrders",
  components: {
    LoadingAnimation,
    StatusIndicator,
  },
  setup(_props, ctx) {
    const $store = ctx.root.$store;

    const firstInput = ref<null | HTMLInputElement>(null);

    const filter = ref("");

    const sortKey = ref<keyof WorkOrderSimple>("name");
    const sortAsc = ref(true);

    const dataLoaded = ref(false);
    const loadingMessage =
      "Loading work orders...Dragging them in from the database...";

    const updateSort = (lSortKey: keyof WorkOrderSimple) => {
      workOrders.value = genericSort(
        [...workOrders.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    const getWorkOrdersByStartDate = () => {
      dataLoaded.value = false;
      const jsConn = new JSConn();

      // 2020-08-20
      // Using the dates for this year
      // this may need to be changed. It could be stored in the store
      // the logic could be handled in the controller.
      const td = new Date();

      jsConn.formParams = {
        from_start_date: format(startOfYear(td), "yyyy-MM-dd"),
        to_start_date: format(endOfYear(td), "yyyy-MM-dd"),
      };

      return $store.dispatch("needWorkOrders", jsConn).then(() => {
        workOrders.value = [...apiWorkOrders.value];
        dataLoaded.value = true;
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        sortKey.value = "start_date";
        updateSort(sortKey.value);
        dataLoaded.value = true;
        return Promise.resolve();
      });
    };

    const workOrderShow = (wo: WorkOrderSimple) => {
      return {
        name: NamedRts.mWorkOrderTasks,
        params: {
          workOrderId: wo.id,
        },
      };
    };

    onMounted(() => {
      // getWorkOrdersByStatus(currentStatuses);
      getWorkOrdersByStartDate();
    });

    // not actually used in this situation
    const selectedIndex = ref(-1);

    const filterOnInput = ({ target }: { target: HTMLInputElement }) => {
      filterOnInputHandler(
        apiWorkOrders,
        workOrders,

        target.value,
        filter,
        debouncedFilteredWorkOrders,

        sortKey,
        sortAsc,
        updateSort,

        selectedIndex,
      );
    };

    const clearFilter = () => {
      filterOnInputHandler(
        apiWorkOrders,
        workOrders,

        "",
        filter,
        debouncedFilteredWorkOrders,

        sortKey,
        sortAsc,
        updateSort,

        selectedIndex,
      );
    };

    return {
      firstInput,
      filter,
      clearFilter,
      filterOnInput,

      loadingMessage,
      dataLoaded,
      workOrders,
      workOrderShow,
    };
  },
});
